module.exports = __webpack_public_path__ + "static/media/bttn_radio.bef5f66d.svg";